<template>
	<v-row align='center' class="mt-1">
		
		<v-col lg="2" md="3" sm="4" cols="12" class="pt-0">
			<v-card class="rounded-lg pa-1" height="232">
				<v-card-text class="pb-0">
					<v-row>
						<v-col cols="12" class="d-flex">
							<v-row >
								<v-col class=" d-flex justify-center ">
									<div>
										<!-- <v-img src="../../assets/Vectors/photo_2024-06-06_18-25-00.jpg" width="80" height="80" class="rounded-circle"></v-img> -->
										<img
											src="@/assets/im.png"
											width="80"
											cover
											height="80"
											class="rounded-circle"
										/>
									</div>
								</v-col>
								<v-col cols="12" class='py-0 d-flex justify-center'>
									<v-icon small class="mx-1"> mdi-account-circle  </v-icon>
									<h4>
										{{
											userData 
											? userData.employee.arabicFirstName + ' ' +userData.employee.arabicLastName 
											: '-' 
										}}
									</h4>
								</v-col>

								<v-col cols="12" class='d-flex align-end justify-center'>
									<v-btn
										width="100%"
										color='primary'
										:to="{ name: 'all-employees' }"
										class="rounded-lg text-none"
										elevation="0"
									>
										All employees
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>

		<!-- statistics -->
		<v-col lg='7' sm="5" cols="12" class="pt-0" :class="{ 'px-0': $vuetify.breakpoint.mdAndUp }">
			<v-card class="rounded-lg pa-1" height="232">
				<h4 class="px-2 py-0">statistics</h4>
				<v-card-text class="h-100 d-flex flex-column">
					<v-row class="d-flex justify-center">
						<v-col sm="6" md="4" class="pb-0">
							<span class='text-color--text fs-xl fw-9'>
								{{ employeeStatics.totalWorkDays > 0 && !loadingEmployeeStatics ? (employeeStatics.totalWorkDays).toFixed(2) : '-' }}
							</span>
							<p 
								class='text-center text-color--text mb-0' 
								:class="{ 'fs-sm': $vuetify.breakpoint.md }"
							>
								Total work Days
							</p>
						</v-col>

						<!-- Total work Time -->
						<v-col sm="6" md="4" class="pb-0">
							<span class='text-color--text fs-xl fw-9'>
								{{ employeeStatics.totalWorkTime > 0 && !loadingEmployeeStatics ? (employeeStatics.totalWorkTime / 60).toFixed(2) : '-' }}
							</span>
							<p 
								class='text-center text-color--text mb-0'
								:class="{ 'fs-sm': $vuetify.breakpoint.md }"
							>
								Total work Time
							</p>
						</v-col>
					</v-row>
					<v-row class="d-flex justify-center mb-0">
						<!-- Working time in the office -->
						<v-col sm="6" md="4">
							<span class='text-color--text fs-l fw-9'>
								<!-- 100 h -->
								{{ employeeStatics.workingTimeAtOffice > 0 && !loadingEmployeeStatics ? (employeeStatics.workingTimeAtOffice / 60).toFixed(2) : '-' }}
							</span>
							<p 
								class='text-start text-color--text mb-0'
								:class="{ 'fs-sm': $vuetify.breakpoint.md }"
							>
								Working time in the office
							</p>
						</v-col>
				
						<!-- Work time at home -->
						<v-col sm="6" md="3">
							<span class='text-color--text fs-l fw-9'>
								{{ employeeStatics.workingTimeAtHome > 0 && !loadingEmployeeStatics ? (employeeStatics.workingTimeAtHome / 60).toFixed(2) : '-' }}
							</span>
							<p
								class='text-start text-color--text mb-0'
								:class="{ 'fs-sm': $vuetify.breakpoint.md }"
							>
								Work time at home
							</p>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>

		<v-col lg="3" md="4" sm="12" class="pt-0">
			<v-card class="rounded-lg"  height="230">
				<v-card-text style="height: 100%" class="pb-0">
					<v-row style="height: 100%">
						<v-col cols='12' sm="6" md="12" class="" align-self="start">
							<v-btn-toggle
								v-model="speacifice"
								mandatory
								dense
								class="d-flex rounded-lg justify-center"
								color="primary"
								style="width: 100%"
								:disabled="loadingAll"
							>
								<v-btn 
									:disabled="loading" 
									value="yearly" 
									class="text-none" 
									style="width: 50%"
								> 
									Yearly 
								</v-btn>
								<v-btn
									:disabled="loading"
									value="monthly"
									class="text-none"
									style="width: 50%"
								>
									Monthly
								</v-btn>
								<!-- <v-btn
									:disabled="loading"
									value="period"
									class="text-none"
									style="width: 33%"
								>
									Period 
								</v-btn> -->
							</v-btn-toggle>
						</v-col>

						<v-col
							v-if="speacifice !== 'period'"
							cols="12"
							align-self="start"
							class="d-flex align-center mx-2 py-1"
						>
							<v-autocomplete
								v-model="year"
								:items="years"
								item-text="name"
								item-value="name"
								hide-details='auto'
								label="Year"
								dense
								class="rounded-lg input"
								:disabled="loadingAll"
								prepend-icon=""
								append-icon=""
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
							/>

							<div class="d-flex flex-column">

								<v-btn icon x-small @click="addYear()" :disabled="!year || loadingAll">
									<v-icon small>
										mdi-menu-up
									</v-icon>									
								</v-btn>

								<v-btn
									icon
									x-small
									@click="subYear()"
									:disabled="!year || years.indexOf(year) === 0 || loadingAll"
								>
									<v-icon small>
										mdi-menu-down
									</v-icon>									
								</v-btn>
							</div>
						</v-col>

						<v-col
							v-if="speacifice === 'monthly'"
							cols="12"
							align-self="start"
							class="d-flex align-center mx-2 py-1"
						>
							<v-autocomplete
								v-model="month"
								:items='months'
								item-text="name"
								item-value="value"
								label="Month"
								class="rounded-lg input"
								hide-details='auto'
								dense
								:disabled="!year || loadingAll"
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								solo
								append-icon=""
							></v-autocomplete>

							<div class="d-flex flex-column">
								<v-btn icon x-small @click="addMonth()" :disabled="!month || loading">
									<v-icon small>
										mdi-menu-up
									</v-icon>									
								</v-btn>
								<v-btn
									icon
									x-small
									@click="subMonth()"
									:disabled="!month || months.indexOf(year) === 0 || loadingAll"
								>
									<v-icon small>
										mdi-menu-down
									</v-icon>									
								</v-btn>
							</div>
						</v-col>

						<v-col 
							v-if="speacifice === 'period'" 
							cols="12"
							:class="{
								'pt-0': $vuetify.breakpoint.mdAndUp
							}"
							class="px-0"
						>
							<bee-date-input
								v-model="fromDate"
								append-icon="mdi-menu-right"
								@click:append="upDayFrom(fromDate)"
								prepend-icon="mdi-menu-left"
								@click:prepend="downDayFrom()"
								label="Start date"
								input-format-order="DD-MM-YYYY"
								dense
								class="rounded-lg"
								hide-details
								:disabled="loadingAll"
							></bee-date-input>
						</v-col>

						<v-col
							v-if="speacifice === 'period'" 
							cols="12"
							:class="{
								'pt-0': $vuetify.breakpoint.mdAndUp
							}"	
							class="px-0"
						>
							<bee-date-input
								v-model="toDate"
								append-icon="mdi-menu-right"
								@click:append="upDayTo()"
								prepend-icon="mdi-menu-left"
								@click:prepend="downDayTo()"
								label="End date"
								input-format-order="DD-MM-YYYY"
								dense
								class="rounded-lg"
								hide-details
								:disabled="loadingAll"
							></bee-date-input>
						</v-col>

						<v-col cols="12" class="pt-0 pb-1" align-self="center" style="">
							<v-btn
								color="dark-blue white--text"
								class="rounded-lg text-none"
								width="100%"
								@click="getAllStat()"
								:disabled="loadingAll || (speacifice === 'period' && !fromDate && !toDate)"
							>
								search
							</v-btn>
						</v-col>
					</v-row>
		
				</v-card-text>
			</v-card>
		</v-col>
		<!-- permanence -->
		<v-col cols="12" class="pt-0 px-2">
			<v-card class="rounded-lg">
				<v-card-text>
					<v-row>
						<v-col cols="auto">
							<h4>Permanence rate</h4>
						</v-col>

						<v-spacer />
						<!-- chart permanence -->
						<v-col cols="12" lg="12">
							<v-progress-linear
								v-if="loadingHourForEmployee"
								color="primary"
								indeterminate
							></v-progress-linear>
							<apexchart
								v-else
								type="bar"
								height='250'
								width='90%'
								:options="chartOptionsPerformance"
								:series="statisticsHourForEmployee"
							></apexchart>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>

		<!-- chart project -->
		<v-col cols="12" class="pt-0">
			<v-card class="mt-3 rounded-lg">
				<v-card-text>
					<v-row>
						<v-col cols="auto">
							<h4>Projects</h4>
						</v-col>

						<v-spacer />

						<v-col cols="2">	
							<v-autocomplete
								v-model="projectId"
								:items="projectsBrief"
								item-text="name"
								item-value="id"
								label="Projects"
								dense
								hide-details
								filled	
								:disabled="loading"
								:loading="loading"
								clearable
								@change="getProjectForEmployee()"
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								class="input rounded-lg"
							>	
							</v-autocomplete>
						</v-col>
					
						<v-col cols="12">	
							<v-progress-linear
								v-if="loadingProjectForEmployee"
								color="primary"
								indeterminate
							></v-progress-linear>
							<apexchart
								v-else
								type="bar"
								height='250'
								width='90%'
								:options="!loadingProjectForEmployee ? chartOptionsProject : {}"
								:series="!loadingProjectForEmployee ? seriesProject : []"
							></apexchart>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
		<!-- tags -->
		<v-col cols="12" class="pt-0">
			<v-card class="mt-3 rounded-lg mb-5" height="">
				<v-card-text>
					<v-row>
						<v-col cols="auto">
							<h4>Tags</h4>
						</v-col>

						<v-spacer />
						<v-col 
							cols="2" 
							class="d-flex align-end"
						>
							<v-autocomplete 
								v-model="tagId"
								:items="tags"
								item-text="name"
								item-value="id"
								dense
								filled
								label="Tag"
								hide-details
								@change="getEmployeeTags()"
								:disabled="loadingAll"
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								class="input rounded-lg"
							/>
						</v-col>

						<v-col cols='12' class='d-flex'>
							<v-col cols="11">
								<!-- <bar-chart
									type="bar"
									height='250'
									width='100%'
									:series='seriesTags'
									:categories="tagsName"
								></bar-chart> -->
								<v-progress-linear
									v-if="loadingTagsForEmployee"
									color="primary"
									indeterminate
								></v-progress-linear>
								<apexchart
									v-else
									type="bar"
									height='250'
									width='90%'
									:options="!loadingTagsForEmployee ? chartOptionsTags : {}"
									:series="!loadingTagsForEmployee ? seriesTags : []"
								></apexchart>
							</v-col>
						
							<!-- <div class='align-self-center justify-self-end text-center px-2 varianc'>
								<p class='my-0'>Varianc</p>
								<div
									class='px-5 py-5 m-auto'
									:class='$vuetify.theme.dark ? "varianc-square-dark" : "varianc-square-light" '
								>
									{{ (0.7).toLocaleString('en-US') }} h
								</div>
							</div> -->
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>

		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { userTypeArray } from '@/helper/enum'
export default {
	data () {
		return {
			name: this.$route.query.id,
			type: null,
			loading: false,
			ischart: '1',
			ischartTwo: true,
			speacifice: 'monthly',
			checkbox: false,
			
			yearsAndAll: [2023, 2022, 2021, 2020, 'All'],
			timelly: ['annually', 'monthly'],
			months: [
				'January ',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December'
			],
			projects: ['Edunix', 'Pos', ' Mirta', 'Starling'],
			// seriesTags: [
			// 	{
			// 		name: 'Inf',
			// 		data: [30, 56]
			// 	}
			// ],
			usersId: [this.$route.query.id],
			permanence: {
				month: null,
				year: '2020'
			},
			toDate: null,
			fromDate: null,
			versions: [
				{
					id: 0,
					name: 'V1.0.0'
				},
				{
					id: 1,
					name: 'V1.0.1'
				},
				{
					id: 2,
					name: 'V1.0.2'
				},
				{
					id: 3,
					name: 'V1.0.3'
				}
			],
			statisticsHourForEmployee: [],
			employeeStatics: {
				workingTimeAtHome: 0,
				workingTimeAtOffice: 0,
				totalWorkTime: 0,
				totalWorkDays: 0
			},
			statisticsProject: [],
			categoriesHourForEmployee: [],
			year: moment().year(),
			month: null,
			loadingHourForEmployee: false,
			loadingProjectForEmployee: false,
			loadingEmployeeStatics: false,
			loadingTagsForEmployee: false,
			userTypeArray,
			tagsProjects: [],
			projectId: null,
			tagId: null
		}
	},

	computed: {
		loadingAll () {
			return this.loadingHourForEmployee || this.loadingProjectForEmployee || this.loadingEmployeeStatics || this.loadingTagsForEmployee
		},
		years () {
			const years = []
			// get from create project
			const createdAt = '2020-10-10T10:10:29'
			const year = +(moment(createdAt).format('YYYY'))
			const yearNow = moment().year()
			for (let i = year; i <= yearNow; i++) {
				years.push(
					i
				)
			}
			return years
		},
		...mapState({
			tags: state => state.tags.tags,
			projectsBrief: state => state.projects.projectsBrief,
			userData: state => state.users.myData
		}),

		...mapGetters({
			getUserByName: 'users/getUserByName',
			getProjectById: 'projects/getProjectById',
			getTagById: 'tags/getTagById'
		}),
	
		projectName () {
			return this.statisticsProject.map(c => this.getProjectById(c.projectId)?.name)
		},
		seriesProject () {
			const seriesProject = [ 
				{
					name: 'Inflation',
					data: this.statisticsProject.map(c => (c.workingHours / 60)?.toFixed(2))

				}
			]
			return seriesProject
		},

		// tagsName () {
		// 	return Object.keys(this.tags)
		// },

		tagsName () {
			if (this.tagsProjects.length) {
				return this.tagsProjects?.map(c => this.getTagById(c.tagId)?.name)
			} else {
				return []
			}
		},

		getFromDate () {
			const monthNumber = this.months.indexOf(this.month) + 1
			let fromDate = null
			if (this.speacifice === 'yearly') {
				fromDate = this.moment(this.moment((this.year).toString())).format('YYYY-MM-DD') 
			} else if (this.speacifice === 'monthly') { 
				fromDate = this.year + '-' + (
					monthNumber >= 10 ? monthNumber : '0' + monthNumber
				) + '-' + '01'
			} else {
				fromDate = this.fromDate
			}
			return fromDate
		},
		getToDate () {
			const monthNumber = (this.months.indexOf(this.month) + 1).toString()
			let toDate = null
			if (this.speacifice === 'yearly') { 
				toDate = this.moment(this.moment((this.year).toString()).endOf('year')).format('YYYY-MM-DD') 
			} else if (this.speacifice === 'monthly') {	  
				toDate = this.year + '-' + (
					monthNumber >= 10 
						? monthNumber 
						: '0' + monthNumber
				) + '-' + moment(moment(monthNumber).endOf('month')).format('DD')
			} else {
				toDate = this.toDate
			}
			return toDate
		},

		chartOptionsProject () {
			return {
				chart: {
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					type: 'category',
					categories: this.projectName.length ? this.projectName : []
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		},

		chartOptionsTags () {
			return {
				chart: {
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					categories: this.tagsName
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		},

		seriesTags () {
			return	[
				{
					name: 'Inf',
					data: this.tagsProjects.length ? this.tagsProjects?.map(c => (c.spentTime / 60).toFixed(2)) : []
				}
			]
		},

		chartOptionsPerformance () {
			return {
				chart: {
					type: 'bar'
				},
				plotOptions: {
					bar: {
						borderRadius: 5,
						dataLabels: {
							position: 'top'
						}
					}
				},
				dataLabels: {
					enabled: true,
					formatter: function (val) {
						return val
					},
					offsetY: 10,
					style: {
						fontSize: '12px'
					}
				},
				yaxis: {
					labels: {
						show: true
					}
				},
				markers: {
					size: 5
				},
				xaxis: {
					type: 'category',
					categories: this.categoriesHourForEmployee
				},
				tooltip: {
					enabled: false
				},
				grid: {
					show: true
				},
				theme: {
					mode: this.$vuetify.theme.dark ? 'dark' : 'light'
				}
			}
		}
	},

	methods: {
		// getStatEmployeeOverview () {
		// 	this.$store.dispatch('statsctics/fetchEmpOverViewStat', {
		// 		fromDate: 
		// 		this.permanence.month === null ? this.moment(this.permanence.year).startOf('year').format('DD-MM-YYYY') : `01-${'0' + this.permanence.month}-${this.permanence.year}`,
		
		// 		toDate: this.permanence.month === null ? this.moment(this.permanence.year).endOf('year').format('DD-MM-YYYY') : `${this.moment(this.permanence.month).daysInMonth()}-${'0' + this.permanence.month}-${this.permanence.year}`,
		// 		userIds: this.usersId
		// 	})
		// },
		moment,

		addYear () {
			this.year = this.years[this.years.indexOf(this.year) + 1]
		},
		subYear () {
			this.year = this.years[this.years.indexOf(this.year) - 1]
		},
		addMonth () {
			this.month = this.months[this.months.indexOf(this.month) + 1]
		},
		subMonth () {
			this.month = this.months[this.months.indexOf(this.month) - 1]
		},
		upDayFrom () {
			this.fromDate = moment(this.fromDate).add(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},
	
		downDayFrom () {
			this.fromDate = moment(this.fromDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.fromDate
		},

		upDayTo () {
			this.toDate = moment(this.toDate).add(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},
	
		downDayTo () {
			this.toDate = moment(this.toDate).subtract(1, 'day').format('YYYY-MM-DD')
			return this.toDate
		},

		getHourForEmployee () {
			this.loadingHourForEmployee = true
			this.$store.dispatch('statsctics/fetchHourForEmployee', { 
				userId: this.$route.query.id, 
				fromDate: this.getFromDate, 
				toDate: this.getToDate,
				annualy: this.speacifice === 'yearly',
				withEmptyDates: true
			}).then((data) => {
				this.statisticsHourForEmployee = [ 
					{
						name: 'Inflat',
						data: data.length ? data?.map(c => (c.workTime / 60)?.toFixed(2)) : []

					}
				]
				this.categoriesHourForEmployee = data?.map(c => this.speacifice === 'monthly' ? moment(c.date).format('DD') : moment(c.date).format('MM'))
			}).finally(() => {
				this.loadingHourForEmployee = false
			})
		},
		getProjectForEmployee () {
			this.loadingProjectForEmployee = true
			this.$store.dispatch('statsctics/fetchProjectForEmployee', { 
				id: this.$route.query.id,
				projectId: this.projectId,
				fromDate: this.getFromDate, 
				toDate: this.getToDate,
				annualy: this.speacifice === 'yearly',
				// withEmptyDates: true
				withoutDuplicate: true
			}).then((data) => {
				this.statisticsProject = data
			}).finally(() => {
				this.loadingProjectForEmployee = false
			})
		},
		getEmployeeStatics () {
			this.loadingEmployeeStatics = true
			this.$store.dispatch('statsctics/fetchEmployeeStatics', { 
				userId: this.$route.query.id
				// fromDate: this.getFromDate, 
				// toDate: this.getToDate,
				// annualy: this.speacifice === 'yearly'
			}).then((data) => {
				this.employeeStatics = data
			}).finally(() => {
				this.loadingEmployeeStatics = false
			})
		},

		getEmployeeTags () {
			this.loadingTagsForEmployee = true
			this.$store.dispatch('statsctics/fetchEmployeeTags',
				{
					userId: this.$route.query.id,
					tagId: this.tagId,
					fromDate: this.getFromDate,
					toDate: this.getToDate,
					annualy: this.speacifice === 'yearly',
					withoutDuplicate: true
				}
			).then((data) => {
				this.tagsProjects = data
			}).finally(() => {
				this.loadingTagsForEmployee = false
			})
		},

		getAllStat () {
			this.getHourForEmployee(); 
			// this.getEmployeeStatics()
			// this.getProjectForEmployee()
			// if (this.speacifice !== 'yearly') {
			this.getProjectForEmployee()
			this.getEmployeeTags()
			// }
		}

	},	
	created () {
		this.month = this.months[moment().month()]

		// Promise.all([
		if (!this.projectsBrief?.length) this.$store.dispatch('projects/fetchProjectBrief')
		this.$store.dispatch('users/fetchById', { id: this.$route.query.id })
		this.$store.dispatch('tags/fetchAll')
		// ]).then(() => {
		this.getHourForEmployee()
		this.getProjectForEmployee()
		this.getEmployeeStatics()
		this.getEmployeeTags()
		// })
	}
}
</script>
<style scoped>
.varianc {
  width: 100%;
}
.varianc-square-dark {
  width: 88px;
  border: 2px solid rgb(255, 255, 255);
  background: 'white';
  margin: auto;
}
.varianc-square-light {
  width: 88px;
  border: 2px solid #5e5d5d;
  background: 'white';
  margin: auto;
}
</style>
